import { create } from 'zustand';

// Types
interface OrgState {
  upgrade_plan_modal_config: any;
  ai_model: string;
  ai_model_temp: any;
  bulkArchiveData: {
    org?: any;
    orgProgramme?: any;
    gradeIds?: any;
  };
}

interface OrgActions {
  setShowUpgradePlanModal: (config: any) => void;
  setAIModel: (aiModel: string) => void;
  setAIModelTemp: (aiModelTemp: number | null) => void;
  setBulkArchiveData: (data: any) => void;
  resetBulkArchiveData: () => void;
}

type OrgStore = OrgState & OrgActions;

export const useOrgStore = create<OrgStore>((set, get) => ({
  upgrade_plan_modal_config: null,
  ai_model: '',
  ai_model_temp: null,
  bulkArchiveData: {},

  setShowUpgradePlanModal: (config) => {
    set({ upgrade_plan_modal_config: config });
  },

  setAIModel: (aiModel) => {
    set({ ai_model: aiModel });
  },

  setAIModelTemp: (aiModelTemp) => {
    set({ ai_model_temp: aiModelTemp });
  },

  setBulkArchiveData: (data) => {
    set((state) => ({
      bulkArchiveData: {
        ...state.bulkArchiveData,
        ...data,
      },
    }));
  },

  resetBulkArchiveData: () => set({ bulkArchiveData: {} }),
}));

export const selectAIModel = (state: OrgStore) => state.ai_model;
export const selectAIModelTemp = (state: OrgStore) => state.ai_model_temp;
export const selectBulkArchiveData = (state: OrgStore) => state.bulkArchiveData;
